export default __webpack_public_path__ + "static/media/order.3f951872.jpg";